import type { Types } from '@amplitude/analytics-browser';
import { redactLocationIds } from '@features/analytics/utils/redactPathIds';

/**
 * Amplitude's automatic page-view event writes the raw URL into these properties without going
 * through `track()`, so the redaction has to sit in the pipeline rather than in the wrapper.
 */
const LOCATION_PROPERTY_KEYS = [
  '[Amplitude] Page Location',
  '[Amplitude] Page Path',
  '[Amplitude] Page URL',
  'pathname',
] as const;

export const redactPathIdsPlugin = (): Types.EnrichmentPlugin => {
  return {
    name: 'redact-path-ids',
    type: 'enrichment',
    execute: async (event) => {
      const properties = event.event_properties as Record<string, unknown> | undefined;
      if (!properties) {
        return event;
      }
      for (const key of LOCATION_PROPERTY_KEYS) {
        const value = properties[key];
        if (typeof value === 'string') {
          properties[key] = redactLocationIds(value);
        }
      }
      return event;
    },
  };
};
